// Get the value of the "utmMedium" cookie
const mediumValue = getCookieValue(cookieString, "utm_medium");
console.log("utm_medium:", mediumValue);

// Get the value of the "utmCampaign" cookie
const campaignValue = getCookieValue(cookieString, "utm_campaign");
console.log("utm_campaign:", campaignValue);

document.addEventListener("DOMContentLoaded", function(){
  executeCodeOnLoad();
});

function executeCodeOnLoad() {
  if (mediumValue !== null && (mediumValue.toLowerCase() === "cpc")){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector("#btn_amzcom");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_4BEAD29495A2C6B2F9345FABE4D73542_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("uscpc");
        var scriptElement = document.getElementById("attribution-url-json");
        var jsonData = scriptElement.innerHTML.trim();
        var updatedJsonData = jsonData.replace(/maas_adg_DE372AE48576523252BBDE446CCC6C5F_afap_abs/g, "maas_adg_4BEAD29495A2C6B2F9345FABE4D73542_afap_abs");
        scriptElement.innerHTML = updatedJsonData;
        //console.log("Updated JSON data:", updatedJsonData);
        
      }
      /*if (campaignValue.toLowerCase() !== "brand_us"){
        document.getElementById("channel_box").style.display = "none"; 
      }*/
    }
  }
  if (mediumValue !== null && (mediumValue.toLowerCase() === "product_sync" || (campaignValue !== null && campaignValue.toLowerCase() === "sag_organic"))){
    if (window.location.href.includes("/products")) {
      const amazonComButton = document.querySelector("#btn_amzcom");
      if (amazonComButton) {
        let currentHref = amazonComButton.getAttribute("href");
        currentHref = currentHref.replace(/maas=maas_adg_[\w-]*/, 'maas=maas_adg_88081038962033700E949E4C8A3A95DD_afap_abs');
        amazonComButton.setAttribute("href", currentHref);
        console.log("us_shopping");
        var scriptElement = document.getElementById("attribution-url-json");
        var jsonData = scriptElement.innerHTML.trim();
        var updatedJsonData = jsonData.replace(/maas_adg_DE372AE48576523252BBDE446CCC6C5F_afap_abs/g, "maas_adg_88081038962033700E949E4C8A3A95DD_afap_abs");
        scriptElement.innerHTML = updatedJsonData;
        //console.log("Updated JSON data:", updatedJsonData);
      }
    }
  }
}